/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import _ from 'lodash';
import DetailCard from './DetailCard';
import ImageSlider from './ImageSlider';
import { getCategoryById } from '../utils/functions';
import RunningText from './RunningText';
import UnitNumber from './UnitNumber';
import CardDescription from './CardDescription';
import { useStores } from '../use.store';

const PoiDetailCard = observer(({ interactiveRef }) => {
    const { mainStore, mapStore } = useStores();

    const sliderRef = useRef(null);

    const selectedPoi = mainStore.selectedPoiDetail;

    const isAmenity =
        selectedPoi.categoryId === mainStore.config.tenantIds.amenitiesId;

    const firstMedia = isAmenity
        ? selectedPoi.firstMedias?.length > 1
            ? selectedPoi.firstMedias[1]
            : null
        : selectedPoi?.firstMedias?.length > 0 && selectedPoi.firstMedias[0];

    return (
        <DetailCard selectedPoi={selectedPoi} interactiveRef={interactiveRef}>
            <ImageSlider
                sliderRef={sliderRef}
                singleImageSrc={
                    firstMedia
                        ? `poi/${firstMedia}`
                        : isAmenity
                        ? null
                        : `poi/${selectedPoi.logo}`
                }
                multipleImages={
                    isAmenity
                        ? selectedPoi.firstMedias.slice(1)
                        : selectedPoi.firstMedias
                }
                isMultipleImages={
                    selectedPoi?.firstMedias?.length &&
                    (isAmenity
                        ? selectedPoi.firstMedias?.length > 2
                        : selectedPoi.firstMedias?.length > 1)
                }
                folder="pois"
                className="w-full h-fit sm:h-[250px] md:h-[300px] xl:h-[300px] h-xs:h-[130px] h-sm:h-[250px] h-sm2:h-[300px] h-md:h-[300px] h-xl:h-[300px] object-cover"
            />
            <div className="flex items-center gap-3 p-3 h-fit">
                <div className="flex-1 h-fit">
                    {/* Poi's Name */}
                    {selectedPoi?.name && (
                        <RunningText
                            text={selectedPoi.name}
                            className="running-text-6 flex items-center text-[10px] sm:text-[12px] md:text-[14px] font-semibold text-[#1C1C1C] mb-[6px]"
                        />
                    )}

                    {/* Poi's Category */}
                    {selectedPoi?.categoryId && (
                        <p className="uppercase font-regular text-[#949494] text-[8px] sm:text-[10px] md:text-[12px] mb-4 tracking-[.24em]">
                            {
                                getCategoryById(
                                    mapStore.categoryPois,
                                    selectedPoi.categoryId
                                )?.name
                            }
                        </p>
                    )}

                    {selectedPoi && (
                        <UnitNumber
                            poi={selectedPoi}
                            shape={
                                mapStore.currentFreeShape?.length > 0
                                    ? mapStore.currentFreeShape[0]
                                    : null
                            }
                        />
                    )}

                    {/* Poi's Description */}
                    {selectedPoi.description && (
                        <CardDescription
                            description={selectedPoi.description}
                        />
                    )}
                </div>
            </div>
        </DetailCard>
    );
});

export default PoiDetailCard;
